module.exports = __webpack_public_path__ + "hyperion-v2-static/img/test1.b27ba60e.png";